import CopyCode from "../CopyCode/CopyCode";
import { useRef } from "react";
import { createShowcaseBoxStyle } from "../../styles/showcase";

const ModalComponents = () => {
  const boxStyle = createShowcaseBoxStyle(2);
  const modalRef = useRef(null);

  const openModal = () => {
    modalRef.current?.showModal();
  };

  const closeModal = () => {
    modalRef.current?.close();
  };

  const textos = {
    titulo_texto: {
      uno: "Modal One",
      dos: "Modal Two",
      tres: "Modal Three",
      cuatro: "Modal Four",
      cinco: "Modal Five",
      seis: "Modal Six",
    },
  };

  return (
    <div className="flex flex-col gap-y-10">
      <div className={boxStyle.padre}>
        <h2 className={boxStyle.subtitulo}>Normal Modals:</h2>
        {/* Modal 1 */}
        <div className={boxStyle.hijo}>
          <h2 className={boxStyle.titulo}>{textos.titulo_texto.uno}</h2>
          <div className="mx-4 border rounded-xl p-4 bg-black ">
            <div className="modal-one">
              <button
                type="button"
                className="border p-2 rounded w-full "
                onClick={openModal}
              >
                Open Modal
              </button>
              <dialog
                ref={modalRef}
                className="w-[min(30rem,90vw)] rounded p-4 bg-zinc-200 text-zinc-900"
                aria-labelledby="modal-title"
              >
                <h1 id="modal-title" className="mb-4 text-lg font-semibold">Esto es un modal</h1>
                <p className="mb-4">Ejemplo de modal accesible usando la etiqueta dialog.</p>
                <button
                  type="button"
                  className="border p-2 rounded bg-red-500 font-semibold text-zinc-100 hover:scale-95 transition-all w-1/3"
                  onClick={closeModal}
                >
                  Close
                </button>
              </dialog>
            </div>
          </div>
          <CopyCode
            number_code={Math.floor(Math.random() * 10000)}
            code={`<div className="modal-one">
	<button type="button" className="border p-2 rounded w-full" onClick={openModal}>
		Open Modal
	</button>
	<dialog ref={modalRef} className="w-[min(30rem,90vw)] rounded p-4 bg-zinc-200 text-zinc-900" aria-labelledby="modal-title">
		<h1 id="modal-title">Esto es un modal</h1>
		<p>Ejemplo de modal accesible usando la etiqueta dialog.</p>
		<button type="button" className="border p-2 rounded bg-red-500 font-semibold text-zinc-100" onClick={closeModal}>
			Close
		</button>
	</dialog>
</div>`}
          />
        </div>
      </div>
      {/* ///////////////////////////////////// */}
    </div>
  );
};
export default ModalComponents;


